"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const available = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    "aria-labelledby": (title ? `title-available` : '') + (description ? ` desc-available` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-available"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-available"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ulta_available",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Semantic-Badge"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    id: "Badge",
    fill: "#B3FFC4",
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "Icon",
    transform: "translate(4.499998, 6.166664)",
    fill: "#000000"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.46800236,10.0873356 L1.10629777,5.31165987 L1.04776902,5.25572118 C0.798292444,5.05190818 0.446789979,5.05708913 0.212126504,5.26365026 C-0.0502758121,5.49462834 -0.0723176281,5.89216323 0.163227596,6.14998286 L5.01421871,11.4597094 L5.07320771,11.516062 C5.34905614,11.7410919 5.74654987,11.7074348 5.97153631,11.4435571 L14.8510271,1.02915332 L14.8991334,0.964274451 C15.07077,0.690228541 15.0147309,0.344858939 14.7714503,0.145008123 C14.5030869,-0.0754478141 14.1043946,-0.0407010089 13.8794526,0.223124531 L5.46800236,10.0873356 Z",
    id: "Icon-Color"
  }))))));
};
var _default = exports.default = available;